import { render, staticRenderFns } from "./SurveyTable.vue?vue&type=template&id=fec06a12"
import script from "./SurveyTable.vue?vue&type=script&lang=js"
export * from "./SurveyTable.vue?vue&type=script&lang=js"
import style0 from "./SurveyTable.vue?vue&type=style&index=0&id=fec06a12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports